/**
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/PushButton",
    "MW/toolstrip/mixins/property/MnemonicMixin",
    "MW/toolstrip/mixins/property/MnemonicKeyNavDirectionMixin",
    "MW/toolstrip/mixins/property/OrientationMixin",
    "MW/toolstrip/mixins/property/SizeMixin",
    "MW/toolstrip/mixins/property/TypeMixin",
    "MW/toolstrip/mixins/property/IconMixin",
    "MW/toolstrip/mixins/property/IconOverrideMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "MW/toolstrip/mixins/property/TextMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "MW/toolstrip/mixins/property/QuickAccessIconMixin",
    "MW/toolstrip/mixins/property/TooltipMixin",
    "MW/toolstrip/mixins/property/ShowTextMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, PushButton, MnemonicMixin, MnemonicKeyNavDirectionMixin, OrientationMixin,
             SizeMixin, TypeMixin, IconMixin, IconOverrideMixin, DescriptionOverrideMixin, TextMixin,
             TextOverrideMixin, ShortcutMixin, QuickAccessIconMixin, TooltipMixin, ShowTextMixin,
             mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([PushButton, MnemonicMixin, MnemonicKeyNavDirectionMixin,
        OrientationMixin, SizeMixin, TypeMixin, IconMixin, IconOverrideMixin, DescriptionOverrideMixin,
        TextMixin, TextOverrideMixin, ShortcutMixin, QuickAccessIconMixin, TooltipMixin, ShowTextMixin]), {
        visualFamily: "default",

        _setOrientationAttr: function (value) {
            this.inherited(arguments);
            
            if (value === "Horizontal") {
                this.set("HorizontalAlignment", "left");
            } else {
                this.set("HorizontalAlignment", "center");
            }
        }
    });

});
